import { AppRoleKey } from '../entities/app-dim-app';

export const COMPANY_FLAG_ROLES: AppRoleKey[] = [AppRoleKey.experimental_flags, AppRoleKey.indicator_flags];
export const PERSON_FLAG_ROLES: AppRoleKey[] = [AppRoleKey.experimental_flags, AppRoleKey.indicator_flags];
